import { render, staticRenderFns } from "./heat-photos.vue?vue&type=template&id=ab4a5848"
import script from "./heat-photos.vue?vue&type=script&lang=js"
export * from "./heat-photos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports